import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a039a29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outbound-content" }
const _hoisted_2 = { class: "outbound-form-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Field"),
  /*#__PURE__*/_createElementVNode("h5", null, "MAPPED TO")
], -1 /* HOISTED */))
const _hoisted_4 = { class: "form-wrapper" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "mapping-fields" }
const _hoisted_7 = {
  class: "change-fields",
  "data-cy": "change-field"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-edit-outline" }, null, -1 /* HOISTED */))
const _hoisted_9 = {
  key: 0,
  class: "popover-wrapper"
}
const _hoisted_10 = { class: "ca-fields-wrapper" }
const _hoisted_11 = {
  class: "ca-fields",
  style: {"height":"260px"}
}
const _hoisted_12 = { class: "clear-action" }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ecom_tab_pane = _resolveComponent("ecom-tab-pane")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_vue_scroll = _resolveComponent("vue-scroll")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_ecom_tabs = _resolveComponent("ecom-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTabs)
      ? (_openBlock(), _createBlock(_component_ecom_tabs, {
          key: 0,
          modelValue: _ctx.currentName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentName) = $event)),
          "pane-width": "18",
          "content-width": "82",
          iconed: "",
          onTabClicked: $options.tabClicked
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_vue_scroll, {
                  ref: "vs",
                  onHandleScroll: $options.handleScroll
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.fieldsFormattedForThisComponent, (categoryFields, category) => {
                      return (_openBlock(), _createElementBlock("div", {
                        id: category.toString(),
                        key: category,
                        class: "fields-wrapper"
                      }, [
                        _createElementVNode("h4", null, _toDisplayString($options.getSpacedName(category)), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryFields, (value, key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: key,
                            class: _normalizeClass(`mapping-field-wrapper ${
                    _ctx.newMapping[key].newToField ? 'active' : ''
                  }`)
                          }, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("h6", null, _toDisplayString($options.getSpacedName(key)), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              _hoisted_8,
                              _createVNode(_component_el_popover, {
                                placement: "bottom",
                                width: "550",
                                visible: _ctx.fieldsEditModalVisibility[key]
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => ($options.handlePopOver(key)), ["prevent"])
                                  }, _toDisplayString(_ctx.newMapping[key].newToField
                            ? _ctx.newMapping[key].newToField
                            : _ctx.newMapping[key].default), 9 /* TEXT, PROPS */, _hoisted_13)
                                ]),
                                default: _withCtx(() => [
                                  (_ctx.fieldsEditModalVisibility[key])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.searchQuery,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                                            placeholder: "Type something"
                                          }, {
                                            suffix: _withCtx(() => [
                                              _createVNode(_component_el_icon, { class: "el-input__icon" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Search)
                                                ]),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["modelValue"]),
                                          _createElementVNode("div", _hoisted_11, [
                                            _createVNode(_component_vue_scroll, {
                                              ref_for: true,
                                              ref: "vs-pop-over"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_radio_group, {
                                                  modelValue: _ctx.newMapping[key].newToField,
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.newMapping[key].newToField) = $event)
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.fieldsSearchResult, (field, index) => {
                                                      return (_openBlock(), _createBlock(_component_el_radio, {
                                                        key: index,
                                                        "data-cy": "new-mapping-field",
                                                        label: field,
                                                        onChange: ($event: any) => ($options.closeFieldPopover(key))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(field), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "onChange"]))
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1536 /* NEED_PATCH, DYNAMIC_SLOTS */)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                          _createVNode(_component_el_link, {
                                            style: {"float":"right","color":"#409eff","font-weight":"bold"},
                                            underline: false,
                                            onClick: _withModifiers(($event: any) => ($options.closeFieldPopover(key)), ["prevent"])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Cancel")
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["visible"])
                            ])
                          ], 2 /* CLASS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 8 /* PROPS */, _hoisted_5))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onHandleScroll"])
              ])), [
                [_directive_loading, _ctx.loading]
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock(_component_ecom_tab_pane, {
                key: tab.name,
                label: tab.label,
                name: tab.name,
                lazy: "",
                icon: _ctx.iconMap[tab.name]
              }, null, 8 /* PROPS */, ["label", "name", "icon"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "onTabClicked"]))
      : _createCommentVNode("v-if", true)
  ]))
}